import React, { Component } from 'react'
import { connect } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import WindowSpinner from '../WindowSpinner'
import { notify } from 'react-notify-toast'
import { db } from '../../pouchdb'

import Dropzone from '../Dropzone'

import {
  addFileToQueue,
  uploadProcessing,
  uploadEndProcessing
} from '../../actions'
import { uiConstants, envConstants } from '../../constants'
import { uiHelper } from '../../helpers'

const initialState = {
  queue: [],
  uploadGroup: uuidv4(),
  loadingFiles: false
}

class PhotoUploader extends Component {
  constructor(props) {
    super(props)
    this.handleDrop = this.handleDrop.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.inputReference = React.createRef()
    this.state = initialState
  }

  escFunction(event) {
    switch (event.keyCode) {
      case 27:
        this.resetQueue()
        break
      default:
        break
    }
  }

  resetQueue() {
    const s = this.state
    s.queue.forEach((f) => {
      db.get(f._id).then((doc) => {
        db.remove(doc)
      })
    })
    this.setState({ queue: [] })
  }

  uploadFiles() {
    const s = this.state
    const fl = s.queue.length - 1
    this.props.uploadProcessing()
    s.queue.forEach((f, index) => {
      db.get(f._id).then((doc) => {
        doc.status = envConstants.upload.must_be_sent
        doc.chunks = doc.chunks.map((c) => {
          return {
            ...c,
            status: envConstants.upload.must_be_sent
          }
        })
        db.put(doc).then(() => {
          const chunks = doc.chunks.map((c) => {
            delete c.data
            return c
          })
          this.props.addFileToQueue({
            chunks,
            name: doc.name,
            size: doc.size,
            _id: doc._id,
            marker: doc.marker
          })
          if (fl === index) {
            this.setState({ queue: [] })
            this.props.uploadEndProcessing()
            notify.show('File accodati', uiConstants.toast.success, 3000)
          }
        })
      })
    })
  }

  handleDrop(files) {
    console.log(files)
    if (files.length > 0) {
      const role = uiHelper.getActiveRole()
      this.setState({ loadingFiles: true })
      Object.keys(files).forEach((i) => {
        const upload_group = uuidv4()
        const f = files[i]
        const reader = new window.FileReader()
        reader.onloadend = () => {
          const type = reader.result.split(';')[0].split(':')[1]
          const data = reader.result.split(',')[1]
          const _id = uuidv4()

          const chunk = data.match(/.{1,1048576}/g)
          const chunkSize = Math.ceil(f.size / chunk.length)
          const chunks = []
          chunk.forEach((c, index) => {
            chunks.push({
              chunk_number: index,
              data: c,
              status: envConstants.upload.saved_locally,
              chunk_size: chunkSize
            })
          })
          const doc = {
            _id,
            name: f.name,
            upload_group,
            groupId: role.id,
            userId: role.userId,
            size: f.size,
            status: envConstants.upload.saved_locally,
            chunks,
            file_type: type,
            footprint: this.props.footprint
          }
          db.put(doc).then(() => {
            const s = this.state
            this.setState({
              queue: s.queue.concat({
                size: f.size,
                _id
              }),
              loadingFiles:
                parseInt(i) === files.length - 1 ? false : s.loadingFiles
            })
          })
        }
        reader.readAsDataURL(f)
      })
    }
  }

  fileUploadAction() {
    this.inputReference.current.click()
  }

  componentDidMount() {
    this.props.onRef(this)
    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    const s = this.state
    const { loading } = this.props.upload
    const { canDrag } = this.props
    return (
      <div>
        <input
          type='file'
          onChange={(e) => this.handleDrop(e.target.files)}
          hidden
          multiple
          ref={this.inputReference}
        />
        {canDrag && <Dropzone handleDrop={this.handleDrop}></Dropzone>}
        {s.queue.length > 0 && (
          <>
            {/* onClick={() => this.resetQueue()} */}
            <div className='search-form-bkg deny'></div>
            <div className='search-form'>
              <h1>Caricamento foto</h1>

              <ul className='ul-upload'>
                <li>
                  <label>Numero file:</label>
                  {s.queue.length}
                </li>
                <li>
                  <label>Dimensioni:</label>
                  {uiHelper.byteToMega(
                    s.queue.reduce((a, b) => a + (b.size || 0), 0)
                  )}
                </li>
              </ul>
              <ul className='modal-buttons'>
                <li>
                  <button
                    className='lnk-login'
                    onClick={() => this.resetQueue()}
                  >
                    Annulla
                  </button>
                </li>
                <li>
                  <button
                    className='lnk-login'
                    onClick={() => this.uploadFiles()}
                  >
                    Invia
                  </button>
                </li>
              </ul>
            </div>
          </>
        )}
        {(s.loadingFiles || loading) && <WindowSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  addFileToQueue,
  uploadProcessing,
  uploadEndProcessing
})(PhotoUploader)
